import React from "react";
import { CustomCard } from "../../CustomCard";
import { Box, Divider } from "@material-ui/core";
import { Skeleton, TimelineConnector } from "@material-ui/lab";

// styles
import useStyles from "./styles";

const PropertyTimelineComponentSkeleton = ({}) => {
  const styles = useStyles();

  return (
    <CustomCard
      borderRadius="xl"
      borderColor="secondary"
      classes={styles.wrapperPropretyTimeLine}
    >
      <Box className={styles.continerHeaderCard}>
        <Skeleton variant="text" width={100} height={40} />
        <Divider className={styles.divider} />
      </Box>
      <Box className={styles.containerBodyCard}>
        {[...Array(4)].map((_, index) => (
          <Box key={index} className={styles.containerDate}>
            <Box className={styles.containerIconAndVerticalLine}>
              <Skeleton
                variant="rect"
                width={45}
                height={45}
                style={{ borderRadius: "10px" }}
              />
              {index !== 3 && (
                <TimelineConnector className={styles.timelineConnector} />
              )}
            </Box>
            <Box className={styles.containerData}>
              <Skeleton variant="text" width={100} height={25} />
              <Skeleton variant="text" width={100} height={25} />
            </Box>
          </Box>
        ))}
      </Box>
    </CustomCard>
  );
};

export default PropertyTimelineComponentSkeleton;
